import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-avatar-photo',
  templateUrl: './avatar-photo.component.html',
  styleUrls: [ './avatar-photo.component.scss' ]
})
export class AvatarPhotoComponent implements OnChanges {


  @Input() public photoUrl: string;
  @Input() public name: string;
  @Input() public color: string;
  @Input() public active: boolean = true;
  @Input() public width: string = '60px';
  @Input() public height: string = '60px';

  public showInitials = false;
  public initials: string;
  public circleColor: string;

  private colors = [
    '#8DBA38',
    '#AACB69',
    '#00AC8E',
    '#60AD9D',
    '#286452',
    '#5A8978',
    '#F28E2A',
    '#E2A567'
  ];

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.photoUrl) {
      this.showInitials = true;
      this.createInitials();

      const randomIndex = Math.floor(Math.random() * Math.floor(this.colors.length));
      this.circleColor = this.color ? this.color : this.colors[randomIndex];
    }

  }

  private createInitials(): void {
    let initials = '';

    for (let i = 0; i < this.name.length; i++) {
      if (this.name.charAt(i) === ' ') {
        continue;
      }

      if (this.name.charAt(i) === this.name.charAt(i).toUpperCase()) {
        initials += this.name.charAt(i);

        if (initials.length === 2) {
          break;
        }
      }
    }

    this.initials = initials;
  }

}
